import { Modal } from '../../../shared/styles/components/modal.styles';
import { rgba } from '../../../shared/styles/core/utils';
import styled from '@emotion/styled';
import { theme } from '../../../shared/styles/core/theme';
import { tokens } from '../../../shared/styles/core/tokens';
import { DetailsPanel } from '../../../shared/styles/components/details-panel.styles';

export const DropdownWithClear = styled.div`
   position: relative;
`;

export const ClearButton = styled.button`
   position: absolute;
   top: 0;
   right: 0;
   padding: 0;
   background: none;
   border: none;
   color: ${theme.colors.text.secondary};
   cursor: pointer;
   font-size: ${tokens.font.size.md};
   text-decoration: underline;

   &:hover {
      color: ${theme.colors.text.primary};
   }
`;

export const DropdownGrid = styled.div`
   display: grid;
   grid-template-columns: repeat(4, 1fr);
   gap: ${tokens.space.md};
   margin-bottom: ${tokens.space.md};

   @media (max-width: 1200px) {
      grid-template-columns: repeat(2, 1fr);
   }

   @media (max-width: 768px) {
      grid-template-columns: 1fr;
   }
`;

export const HistoryNavigation = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   gap: ${tokens.space.sm};
   margin-top: ${tokens.space.md};
   padding-top: ${tokens.space.sm};
   border-top: ${tokens.border.thin} ${theme.colors.border.subtle};
`;

export const TabContainer = styled.div`
   display: flex;
   gap: ${tokens.space.xs};
   margin-bottom: ${tokens.space.md};
   border-bottom: ${tokens.border.thin} ${theme.colors.border.default};
`;

export const Tab = styled.button<{ $active: boolean }>`
   padding: ${tokens.space.sm} ${tokens.space.md};
   background: none;
   border: none;
   border-bottom: ${tokens.border.thick} ${({ $active }) => ($active ? theme.colors.border.focus : 'transparent')};
   color: ${({ $active }) => ($active ? theme.colors.text.primary : theme.colors.text.secondary)};
   font-weight: ${({ $active }) => ($active ? tokens.font.weight.semibold : tokens.font.weight.normal)};
   font-size: ${tokens.font.size.md};
   cursor: pointer;
   transition: ${tokens.transition.fast};
   margin-bottom: -1px;

   &:hover {
      color: ${theme.colors.text.primary};
   }
`;

export const WideModalContainer = styled(Modal.Container)`
   max-width: 1400px;
   width: 95vw;
`;

export const WideModalContent = styled(Modal.Content)`
   padding-top: ${tokens.space.lg};
   padding-bottom: ${tokens.space.lg};
`;

export const FooterValidationMessage = styled.span`
   display: flex;
   align-items: center;
   gap: ${tokens.space.xs};
   color: ${theme.colors.state.error};
   font-size: ${tokens.font.size.sm};
   font-weight: ${tokens.font.weight.semibold};
`;

export const ChartLayout = styled.div`
   display: flex;
   flex-direction: column;
   gap: ${tokens.space.md};
`;

export const ChartControls = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.md};
   flex-wrap: wrap;
   margin-bottom: ${tokens.space.md};
`;

export const ChartControlGroup = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.sm};
`;

export const FeedstockToggle = styled.button<{ $active: boolean; $color: string }>`
   padding: ${tokens.space.xs} ${tokens.space.sm};
   border: ${tokens.border.thin} ${({ $active, $color }) => ($active ? $color : theme.colors.border.default)};
   border-radius: ${tokens.radius.sm};
   background-color: ${({ $active, $color }) => ($active ? rgba($color, 0.1) : theme.colors.bg.primary)};
   color: ${({ $active, $color }) => ($active ? $color : theme.colors.text.secondary)};
   font-weight: ${({ $active }) => ($active ? tokens.font.weight.semibold : tokens.font.weight.normal)};
   font-size: ${tokens.font.size.md};
   cursor: pointer;
   transition: ${tokens.transition.fast};

   &:hover {
      border-color: ${({ $color }) => $color};
   }
`;

export const DismissibleAlertRow = styled.div`
   display: flex;
   justify-content: space-between;
   align-items: center;
   gap: ${tokens.space.sm};
`;

export const ModalTitleRow = styled.div`
   display: flex;
   align-items: center;
   gap: ${tokens.space.lg};
`;

export const DetailsPanelCloseWrapper = styled.div`
   position: absolute;
   top: ${tokens.space.sm};
   right: ${tokens.space.sm};
   z-index: 1;
`;

export const PositionedDetailsContainer = styled(DetailsPanel.Container)`
   position: relative;
`;

export const DetailsPanelLabel = styled.div`
   padding: ${tokens.space.sm} ${tokens.space.md} 0;
   font-size: ${tokens.font.size.md};
   font-weight: ${tokens.font.weight.semibold};
   color: ${theme.colors.text.primary};
`;